import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import {
  ProductCardHeading,
  ProductCardContainer,
  ProductCardBrand,
} from './ProductCardInfo.style'
import ProductCardPriceInfo from '../ProductCardPriceInfo'

const ProductCardInfo = ({
  brand,
  productBrandNameOverride,
  currency,
  description,
  rrpPrice,
  salePrice,
  villagePrice,
  labels,
}) => {
  const labelsContainerRef = useRef(null)

  return (
    <ProductCardContainer ref={labelsContainerRef}>
      <ProductCardPriceInfo
        {...{
          currency,
          rrpPrice,
          salePrice,
          villagePrice,
          labels,
        }}
      />

      <ProductCardBrand>{productBrandNameOverride || brand}</ProductCardBrand>
      <ProductCardHeading>{description}</ProductCardHeading>
    </ProductCardContainer>
  )
}

ProductCardInfo.propTypes = {
  brand: PropTypes.string.isRequired,
  productBrandNameOverride: PropTypes.string,
  currency: PropTypes.string,
  description: PropTypes.string.isRequired,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  labels: PropTypes.shape({}),
}

ProductCardInfo.defaultProps = {
  productBrandNameOverride: '',
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  labels: {},
}

export default ProductCardInfo
